module.exports = __webpack_public_path__ + "static/media/loewy_wine-thursday.b8cfa9d1.jpg";